import React, { createContext, useContext, useMemo } from "react";
import { AuthStateContext } from "./auth-state-context";
import { AuthOperationsContext } from "./auth-operations-context";

// Combined context for backward compatibility
const AuthContext = createContext({});

// Combined provider that merges both state and operations
function AuthProvider({ children }) {
  // This is now just a wrapper that combines both contexts
  // The actual providers are set up in the hierarchy
  return <>{children}</>;
}

// Hook that combines both contexts for backward compatibility
function useAuth() {
  const stateContext = useContext(AuthStateContext);
  const operationsContext = useContext(AuthOperationsContext);

  if (!stateContext) {
    throw new Error('useAuth must be used within AuthStateProvider');
  }

  // Merge both contexts
  return {
    ...stateContext,
    ...operationsContext
  };
}

// For components that directly use useContext(AuthContext)
// We'll create a provider that combines both
function CombinedAuthProvider({ children }) {
  const stateContext = useContext(AuthStateContext);
  const operationsContext = useContext(AuthOperationsContext);

  const value = useMemo(() => ({
    ...stateContext,
    ...operationsContext
  }), [stateContext, operationsContext]);

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export { AuthProvider, AuthContext, useAuth, CombinedAuthProvider };
